import { Zone } from "@/types/api-types";

export const getZoneName = (zone: Zone) => {
  return [zone?.code, zone?.name].filter(Boolean).join(" - ");
};
